function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import RadioButton from '../../radio-button/RadioButton';
import { useFormContext } from '../FormContext';
const RadioButtonAdapter = _ref => {
  let {
    name,
    value,
    ...rest
  } = _ref;
  const {
    values
  } = useFormContext();
  return /*#__PURE__*/React.createElement(RadioButton, _extends({
    name: name,
    value: value
  }, rest, {
    checked: Boolean(values[name] && values[name] === value)
  }));
};
export default RadioButtonAdapter;
//# sourceMappingURL=RadioButtonAdapter.js.map